import { FunctionComponent, useEffect, useState } from 'react';
import { Button, IconButton } from '../../tailwindcomponents';
import { DatePicker } from './../../MaterialUiComponents';
import { Autocomplete, TextField, Typography, Input, Table, TableRow, TableCell } from './../../tailwindcomponents';
import { Search } from '../../components/icons';
import { reportSearchResults } from '../../types/security';
import SecurityApi from '../../api/security';
import { EmployeeSearch } from '../../components';

type ReportInfoProps = {
    openReport: Function,
    tails: string[]
}

const ReportInfo: FunctionComponent<ReportInfoProps> = ({ openReport, tails }) => {

    const [selectedDateFrom, setSelectedDateFrom] = useState<Date | null>(null);
    const [selectedDateTo, setSelectedDateTo] = useState<Date>(new Date());
    const [selectedTail, setSelectedTail] = useState<string | null>("");
    const [searchWord, setSearchWord] = useState<string>("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState<number>(-1);
    const clearEmployee = false;
    const [searchResults, setSearchResults] = useState<reportSearchResults[]>();

    useEffect(() => {
        tails.sort();
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDateFrom, selectedDateTo, selectedTail, searchWord, selectedEmployeeId]);


    const refresh = () => {
        SecurityApi.SearchRequests(selectedDateFrom, selectedDateTo, selectedTail !== null ? selectedTail.toString() : "", searchWord, selectedEmployeeId).then(res => {
            setSearchResults(res);
        });
    }

    const generateTableBody = (row: reportSearchResults, index: number) => {
        return (
            <TableRow >
                <TableCell>{row.general_info.created_date_text_with_no_hours} {row.is_day_shift === true ? ' - Day' : ' - Night'}</TableCell>
                <TableCell>{row.general_info.created_by_employee_name}</TableCell>
                <TableCell>{row.amount_movements}</TableCell>
                <TableCell>{row.amount_call_outs}</TableCell>
                <TableCell>{row.amount_walk_arounds}</TableCell>
                <TableCell>{row.amount_other_incidents}</TableCell>
                <TableCell>{row.general_info.last_modified_date_by_employee_name} </TableCell>
                <TableCell>{row.general_info.last_modified_date_text} </TableCell>
                <TableCell><IconButton onClick={() => onRowClick(row.security_report_id)}><Search color="primary" /></IconButton> </TableCell>
            </TableRow>
        )
    }
    const onRowClick = (reportId: number) => {
        openReport(reportId);
    }

    const onSelectedTail = (tail: string | null) => {
        setSelectedTail(tail);
    }
    const onDateChange = (date: Date, type: string) => {
        if (type === 'from') {
            setSelectedDateFrom(date);
        }
        if (type === 'to') {
            setSelectedDateTo(date);
        }
    }

    const onSelectedEmployeeRow = (employeeId: number) => {
        setSelectedEmployeeId(employeeId || -1);
    }
    const onResetFields = () => {
        setSelectedDateFrom(null);
        setSelectedDateTo(new Date());
        setSelectedTail("");
        setSearchWord("");
        setSelectedEmployeeId(-1);
    }
    // Header of the report. Submit button is only displayed when in edit mode
    return (
        <div className="flex flex-wrap items-end w-full gap-2 ml-4 mb-2">
            <div className="flex flex-wrap w-full sm:w-5/6 md:w-1/3 lg:w-1/6">
                <EmployeeSearch reset={clearEmployee} place_holder={"Created by"} onSelectedEmployee={(employee_id: number) => onSelectedEmployeeRow(employee_id)} />
            </div>
            <div className="flex flex-wrap w-full sm:w-5/12 md:w-1/3 lg:w-1/6">
                <DatePicker onDateChange={(date: Date) => onDateChange(date, 'from')} type={"Date"} label="Created from" selected={selectedDateFrom} />
            </div>
            <div className="flex flex-wrap w-full sm:w-5/12 md:w-1/3 lg:w-1/6" >
                <DatePicker onDateChange={(date: Date) => onDateChange(date, 'to')} type={"Date"} label="Created to" selected={selectedDateTo} />
            </div>
            <div className="flex flex-wrap w-full sm:w-5/12 md:w-1/3 lg:w-1/6" >
                <Autocomplete
                    fullWidth
                    noOptionsText="No tails found"
                    options={tails}
                    value={selectedTail}
                    clearOnEscape
                    autoHighlight
                    onChange={(e: any, newValue: string | null) => onSelectedTail(newValue)}
                    renderInput={(params) => (
                        <TextField {...params} label="Tails" variant="standard" />
                    )} />
            </div>
            <div className="flex flex-wrap w-full sm:w-5/12 md:w-1/3 lg:w-1/6" >
                <Input multiline={true} help_text={""} label_text={"Search"} value={searchWord} onTextChange={(text: string) => setSearchWord(text)} type="text" width={100} />
            </div>
            <div className="flex flex-wrap w-full sm:w-5/12 md:w-1/3 lg:w-1/6" >
                <Button variant="text" className="h-[var(--ds-control-h)] mt-4" color="primary" size="small" onClick={() => onResetFields()}>Reset filters</Button>
            </div>
            <div className="flex flex-wrap w-full">
                <div className="lg:w-1/6 w-1/2 mt-2 text-gray-500">
                    <Typography text={searchResults !== undefined ? searchResults.length + " reports found" : '0 reports found'} />
                </div>
            </div>
            <div className="w-full">
                {searchResults !== undefined &&
                    <Table
                        headers={["Created date", "Created by", "Movements", "Callouts", "Walkarounds", "Other Incidents", "Last modified by", "Last modified date"]}
                        skipIndexCol={true}
                        rows={searchResults}
                        generateBody={(row: any, index: number) => generateTableBody(row, index)}
                        defaultRowsPerPage={25}
                    />
                }
            </div>
        </div>
    );
};
export default ReportInfo;
